import { styled } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
import Pagination from '@mui/material/Pagination';

export const BlogSectionWrapper = styled('section')({
    paddingBottom: '3.7em',
});

export const BlogSectionHero = styled(Grid)({
    background: 'linear-gradient(272.09deg, #653BC0 0%, #29AAE2 100%)',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    height: '14.28em',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
});

export const BlogSectionHeroTitle = styled(Typography)({
    fontWeight: 700,
    fontSize: '5.33em',
    color: '#fff',
    textAlign: 'center',
    lineHeight: '6.14em',
    '@media (max-width: 550px)': {
        fontSize: '2.33em',
    },
});

export const BlogSectionHeroSubtitle = styled(Typography)({
    fontWeight: 500,
    fontSize: '1.71em',
    color: '#fff',
    textAlign: 'center',
    lineHeight: '2.28em',
    '@media (max-width: 550px)': {
        fontSize: '1.33em',
    },
});

export const BlogSectionPostsGrid = styled(Grid)({
    marginTop: '1.7em',
    '@media (max-width: 550px)': {
        flexDirection: 'column-reverse',
    },
});

export const BlogSectionBlogsGrid = styled(Grid)({
    gap: '2em',
    '@media (max-width: 550px)': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export const BlogSectionSidebar = styled(Grid)({
    '@media (max-width: 550px)': {
        marginBottom: '2.5em',
    },
});

export const BlogSectionSearchIcon = styled('img')({
    width: '1.21em',
    height: '1.21em',
    objectFit: 'contain',
});

export const BlogSectionPagination = styled(Pagination)({
    marginTop: '1.7em',
});

